import { Models } from '@mtap-smartcity/api';

export interface ReportsStatus {
  reports: Models.Reports.Report[];
  configs: Models.Reports.Config[];
}

export interface CreateReportRequest {
  object_display_name: string;
  filter_type: 'none' | 'object_id' | 'circuit_uuid' | 'group_uuid';
  filter_value: string;
  start_date: Date;
  end_date: Date;
  type: 'single' | 'scheduled';
  repeating_interval?: 'daily' | 'weekly' | 'monthly';
  created_by: string;
}

export interface ReportsState {
  reportsStatus: ReportsStatus | null;
}

export enum ReportsGetter {
  GetReportsStatus = 'GET_REPORTS_STATUS',
  GetAllReports = 'GET_ALL_REPORTS',
  GetEnabledConfigs = 'GET_ENABLED_CONFIGS',
  GetScheduledConfigs = 'GET_SCHEDULED_CONFIGS',
  GetSingleConfigs = 'GET_SINGLE_CONFIGS'
}

export enum ReportsAction {
  FetchReportsStatus = 'FETCH_REPORTS_STATUS',
  CreateReportConfig = 'CREATE_REPORT_CONFIG',
  DownloadReportPdf = 'DOWNLOAD_REPORT_PDF',
  DownloadReportXls = 'DOWNLOAD_REPORT_XLS',
  DeleteReportConfig = 'DELETE_REPORT_CONFIG',
  CheckReportsExistForConfig = 'CHECK_REPORTS_EXIST_FOR_CONFIG',
  PollConfigCompletion = 'POLL_CONFIG_COMPLETION'
}

export enum ReportsMutation {
  FetchReportsStatusHandler = 'FETCH_REPORTS_STATUS',
  AddReports = 'ADD_REPORTS',
  AddConfig = 'ADD_CONFIG',
  DeleteReportConfigHandler = 'DELETE_REPORT_CONFIG'
}

export type ReportsGetterType = {
  [ReportsGetter.GetReportsStatus]: () => ReportsStatus | null;
  [ReportsGetter.GetAllReports]: () => Models.Reports.Report[];
  [ReportsGetter.GetEnabledConfigs]: () => Models.Reports.Config[];
  [ReportsGetter.GetScheduledConfigs]: () => Models.Reports.Config[];
  [ReportsGetter.GetSingleConfigs]: () => Models.Reports.Config[];
};

export type ReportsActionType = {
  [ReportsAction.FetchReportsStatus]: () => Promise<void>;
  [ReportsAction.CreateReportConfig]: (config: CreateReportRequest) => Promise<Models.Reports.Config>;
  [ReportsAction.DownloadReportPdf]: (reportId: number) => Promise<void>;
  [ReportsAction.DownloadReportXls]: (reportId: number) => Promise<void>;
  [ReportsAction.DeleteReportConfig]: (uuid: string) => Promise<void>;
  [ReportsAction.CheckReportsExistForConfig]: (configUuid: string) => Promise<{ exists: boolean }>;
  [ReportsAction.PollConfigCompletion]: (configUuid: string) => Promise<void>;
};

export type ReportsMutationType = {
  [ReportsMutation.FetchReportsStatusHandler]: (reportsStatus: ReportsStatus) => void;
  [ReportsMutation.AddReports]: (reports: Models.Reports.Report[]) => void;
  [ReportsMutation.AddConfig]: (config: Models.Reports.Config) => void;
  [ReportsMutation.DeleteReportConfigHandler]: (uuid: string) => void;
};
